import { gsap } from '/shared.js';
import { THREE } from '/shared.js';
import { RoundedBoxGeometry } from '/shared.js';
import { DotLottie } from '/shared.js';
import { Splide } from '/shared.js';
import { ScrollTrigger } from '/shared.js';
import * as dat from 'dat.gui';

document.addEventListener('DOMContentLoaded', function () {

    const gui = new dat.GUI();
    gui.hide();




    const canvas = document.getElementById('three-js-elements');
    const stage = document.querySelector('.animation-stage');

    const renderer = new THREE.WebGLRenderer({ canvas, alpha: true, antialias: true });
    const scene = new THREE.Scene();
    const camera = new THREE.PerspectiveCamera(10, 1, 0.1, 1000);

    const geometry = new RoundedBoxGeometry(0.06, 0.06, 0.06, 8, 0.003); // 8 segments, 0.01 radius
    const material = new THREE.MeshPhysicalMaterial({
        color: 0x12887A,
        metalness: 0.2,
        roughness: 1,

    });
    const cube = new THREE.Mesh(geometry, material);
    const cubeGroup = new THREE.Group();
    cubeGroup.add(cube);
    cubeGroup.position.set(.18, -0.03, 0);
    cubeGroup.rotation.set(0, -0.06, -0.55)
    scene.add(cubeGroup);


    //put a point light above the cube
    const pointLightCube = new THREE.PointLight(0xffffff, 5);
    pointLightCube.position.set(0, -1, 1);
    scene.add(pointLightCube);

    const rotationFolder = gui.addFolder('cubeGroup Rotation');
    rotationFolder.add(cubeGroup.rotation, 'x', -Math.PI, Math.PI, 0.01);
    rotationFolder.add(cubeGroup.rotation, 'y', -Math.PI, Math.PI, 0.01);
    rotationFolder.add(cubeGroup.rotation, 'z', -Math.PI, Math.PI, 0.01);
    rotationFolder.open();


    const geometry2 = new RoundedBoxGeometry(0.03, 0.03, 0.03, 8, 0.002); // 8 segments, 0.01 radius

    const cube2 = new THREE.Mesh(geometry2, material);
    const cubeGroup2 = new THREE.Group();
    cubeGroup2.add(cube2);
    cubeGroup2.position.set(-.16, -0.03, 0);
    cubeGroup2.rotation.set(0, -0.06, -0.55)
    scene.add(cubeGroup2);

    //point a point light in front of the cube2
    const pointLightCube2 = new THREE.PointLight(0xffffff, .2);
    pointLightCube2.position.set(-0.16, -0.03, .2);
    // scene.add(pointLightCube2);




    camera.position.z = 2;


    //lights
    const ambientLight = new THREE.AmbientLight(0xffffff, 1);
    scene.add(ambientLight);

    //creat top light
    const directionalLight = new THREE.DirectionalLight(0xffffff, 2);
    directionalLight.position.set(5, 5, 5);
    //scene.add(directionalLight);


    // Hemisphere geometry (half sphere)
    const hemiGeometry = new THREE.SphereGeometry(0.06, 32, 32, 0, Math.PI * 2, 0, Math.PI / 2);
    const hemiMaterial = new THREE.MeshPhysicalMaterial({
        color: 0xA03080,
        metalness: .2,
        roughness: 0.5,
    });
    const hemisphere = new THREE.Mesh(hemiGeometry, hemiMaterial);

    // Cover geometry (circle)
    const coverGeometry = new THREE.CircleGeometry(0.06, 32);
    const coverMaterial = hemiMaterial.clone();

    const cover = new THREE.Mesh(coverGeometry, coverMaterial);
    cover.material.side = THREE.DoubleSide;
    cover.position.y = 0.001; // Move to bottom of hemisphere
    cover.rotation.x = -Math.PI / 2; // Align with open side

    // Group hemisphere and cover

    const halfSphereGroup = new THREE.Group();
    halfSphereGroup.add(hemisphere);
    halfSphereGroup.add(cover);
    halfSphereGroup.scale.set(.7, .7, .7);

    const hemiGroup = new THREE.Group();
    hemiGroup.add(halfSphereGroup);


    hemiGroup.position.set(-0.12, 0.08, 0); // Position away from cube
    hemiGroup.rotation.set(0, 1.53, -1.66);
    scene.add(hemiGroup);



    // Hemisphere geometry (half sphere)
    const hemiGeometry2 = new THREE.SphereGeometry(0.06, 32, 32, 0, Math.PI * 2, 0, Math.PI / 2);
    const hemiMaterial2 = new THREE.MeshPhysicalMaterial({
        color: 0xD4DBF5,
        metalness: .2,
        roughness: 0.5,
        //opacity:0.5,
        //transparent:true,
    });
    const hemisphere2 = new THREE.Mesh(hemiGeometry2, hemiMaterial2);

    // Cover geometry (circle)
    const coverGeometry2 = new THREE.CircleGeometry(0.06, 32);
    const coverMaterial2 = hemiMaterial2.clone();

    const cover2 = new THREE.Mesh(coverGeometry2, coverMaterial2);
    cover2.material.side = THREE.DoubleSide;
    cover2.position.y = 0.001; // Move to bottom of hemisphere
    cover2.rotation.x = -Math.PI / 2; // Align with open side

    // Group hemisphere and cover

    const halfSphereGroup2 = new THREE.Group();
    halfSphereGroup2.add(hemisphere2);
    halfSphereGroup2.add(cover2);
    halfSphereGroup2.scale.set(.9, .9, .9);

    const hemiGroup2 = new THREE.Group();
    hemiGroup2.add(halfSphereGroup2);


    hemiGroup2.position.set(-.165, -.13, 0); // Position away from cube
    hemiGroup2.rotation.set(1.39, -2.49, -3.14);
    scene.add(hemiGroup2);

    const rotationFolder2 = gui.addFolder('hemiGroup2 Rotation');
    rotationFolder2.add(hemiGroup2.rotation, 'x', -Math.PI, Math.PI, 0.01);
    rotationFolder2.add(hemiGroup2.rotation, 'y', -Math.PI, Math.PI, 0.01);
    rotationFolder2.add(hemiGroup2.rotation, 'z', -Math.PI, Math.PI, 0.01);
    rotationFolder2.open();










    //add point light just a bit left to the hemisphere
    const pointLight = new THREE.PointLight(0xffffff, .5);
    pointLight.position.set(-0.5, 0.1, 0.1
    );
    //scene.add(pointLight);




    // dat.GUI for hemisphere group rotation
    const hemiRotationFolder = gui.addFolder('hemiGroup Rotation');
    hemiRotationFolder.add(hemiGroup.rotation, 'x', -Math.PI, Math.PI, 0.01);
    hemiRotationFolder.add(hemiGroup.rotation, 'y', -Math.PI, Math.PI, 0.01);
    hemiRotationFolder.add(hemiGroup.rotation, 'z', -Math.PI, Math.PI, 0.01);
    hemiRotationFolder.open();



    // Cone geometry (sealed cone)
    const coneGeometry = new THREE.ConeGeometry(0.06, 0.1, 32);
    const coneMaterial = new THREE.MeshPhysicalMaterial({
        color: 0xA03080,
        metalness: 0.2,
        roughness: 0.5,
    });
    const cone = new THREE.Mesh(coneGeometry, coneMaterial);

    // Base cover geometry (circle)
    const baseGeometry = new THREE.CircleGeometry(0.06, 32);
    const baseMaterial = coneMaterial.clone();
    const baseCover = new THREE.Mesh(baseGeometry, baseMaterial);
    baseCover.material.side = THREE.DoubleSide;
    baseCover.position.y = -0.05; // Base of cone
    baseCover.rotation.x = -Math.PI / 2; // Align with base

    // Group cone and base cover
    const coneGroup = new THREE.Group();
    coneGroup.add(cone);
    coneGroup.add(baseCover);
    coneGroup.scale.set(0.4, 0.4, 0.4);

    const coneGroupGroup = new THREE.Group();
    coneGroupGroup.add(coneGroup);

    coneGroupGroup.position.set(0.14, 0.05, 0);
    coneGroupGroup.rotation.set(0, 1.53, -1.66);
    scene.add(coneGroupGroup);

    // dat.GUI for cone group rotation
    const coneRotationFolder = gui.addFolder('coneGroup Rotation');
    coneRotationFolder.add(coneGroup.rotation, 'x', -Math.PI, Math.PI, 0.01);
    coneRotationFolder.add(coneGroup.rotation, 'y', -Math.PI, Math.PI, 0.01);
    coneRotationFolder.add(coneGroup.rotation, 'z', -Math.PI, Math.PI, 0.01);
    coneRotationFolder.open();




    //enter all shapes in from the bottom with gsap

    const introTl = gsap.timeline({ delay: 2, paused: true });
    introTl.from(coneGroupGroup.position, { y: -1, duration: 1, ease: "power2.out" });
    introTl.from(cubeGroup.position, { y: -1, duration: 1, ease: "power2.out" }, 0.2);
    introTl.from(cubeGroup2.position, { y: -1, duration: 1, ease: "power2.out" }, 0.4);
    introTl.from(hemiGroup.position, { y: -1, duration: 1, ease: "power2.out" }, 0.6);

    introTl.from(hemiGroup2.position, { y: -1, duration: 1, ease: "power2.out" }, 0.8);





    //animate all shapes slowly


    const cubeRoatationTl = gsap.timeline({ repeat: -1 });

    cubeRoatationTl.to(cube.rotation, { y: 2 * Math.PI, duration: 27, ease: "none" });
    cubeRoatationTl.to(cube.rotation, { x: 2 * Math.PI, duration: 27, ease: "none" }, 0);
    // cubeRoatationTl.to(cube.rotation, {z: 2*Math.PI, duration: 5, ease: "none"}, 0);




    const cube2RoatationTl = gsap.timeline({ repeat: -1 });

    cube2RoatationTl.to(cube2.rotation, { y: 2 * Math.PI, duration: 25, ease: "none" });
    cube2RoatationTl.to(cube2.rotation, { x: 2 * Math.PI, duration: 25, ease: "none" }, 0);
    cube2RoatationTl.to(cube2.rotation, { z: 2 * Math.PI, duration: 25, ease: "none" }, 0);




    const halSphereRoatationTl = gsap.timeline({ repeat: -1 });

    halSphereRoatationTl.to(halfSphereGroup.rotation, { y: 2 * Math.PI, duration: 22, ease: "none" });
    // halSphereRoatationTl.to(halfSphereGroup.rotation, {x: 2*Math.PI, duration: 4.1, ease: "none"}, 0);
    halSphereRoatationTl.to(halfSphereGroup.rotation, { z: 2 * Math.PI, duration: 22, ease: "none" }, 0);


    const conRoatationTl = gsap.timeline({ repeat: -1 });

    conRoatationTl.to(coneGroup.rotation, { y: 2 * Math.PI, duration: 24, ease: "none" });
    // conRoatationTl.to(coneGroup.rotation, {x: 2*Math.PI, duration: 4.5, ease: "none"}, 0);
    conRoatationTl.to(coneGroup.rotation, { z: -2 * Math.PI, duration: 24, ease: "none" }, 0);



    const halSphere2RoatationTl = gsap.timeline({ repeat: -1 });

    halSphere2RoatationTl.to(halfSphereGroup2.rotation, { y: 2 * Math.PI, duration: 20, ease: "none" });
    // halSphereRoatationTl.to(halfSphereGroup.rotation, {x: 2*Math.PI, duration: 4.1, ease: "none"}, 0);
    halSphere2RoatationTl.to(halfSphereGroup2.rotation, { z: 2 * Math.PI, duration: 20, ease: "none" }, 0);





    // coneGroup.rotation.z += 0.01;
    // // coneGroup.rotation.z += 0.01;
    // coneGroup.rotation.y += 0.01;


    // hemiGroup2.rotation.z -= 0.01;
    // // coneGroup.rotation.z += 0.01;
    // hemiGroup2.rotation.y += 0.01;



    const DPR_CAP = 2;
    function resizeRenderer() {
        const width = stage.clientWidth;
        const height = stage.clientHeight;

        renderer.setPixelRatio(Math.min(DPR_CAP, window.devicePixelRatio || 1));
        renderer.setSize(width, height, false);
        camera.aspect = width / height;
        camera.updateProjectionMatrix();
    }

    function animate() {
        requestAnimationFrame(animate);



        renderer.render(scene, camera);
    }

    window.addEventListener('resize', resizeRenderer);
    resizeRenderer();
    animate();

    const element = document.getElementById('hero-lottie');
    // lottie.loadAnimation({
    //     container: element, // the dom element that will contain the animation
    //     renderer: 'svg',
    //     loop: true,
    //     autoplay: true,
    //     path: style_sheet_url+'/assets/lottie/home.lottie' // the path to the animation json
    // });


    const player = new DotLottie({
        canvas: document.getElementById('hero-lottie'),
        src: style_sheet_url + '/assets/lottie/home.lottie', // put the .lottie in /public if using Vite
        //loop: true,
        autoplay: true
    });

    // introTl play when lottie is loaded
    player.addEventListener('play', () => {
        introTl.play();
    });

    /**
     * Solutions splides
     */

    const solutionsController = new Splide('.controller-splide', {
        arrows: false,
        pagination: false,
        autoWidth: true,
        isNavigation: true,
        direction: 'rtl',

        breakpoints: {
            1023: {
                perPage: 1,
                autoWidth: false,
                arrows: true,
                updateOnMove: true,
                arrowPath: "M11.5,2.3l17.7,17.7-17.7,17.7",
                type: 'loop',

            }
        }


    });

    const solutionsTextSplide = new Splide('.solutions-splide', {
        arrows: false,
        pagination: false,
        direction: 'ttb',
        perPage: 1,
        height: '50rem',
        speed: 0,
        updateOnMove: true,
        easing: 'cubic-bezier(0.645, 0.045, 0.355, 1.000)',
        breakpoints: {
            1023: {
                direction: 'rtl',
                height: 'auto',
            }
        }



    });

    const solutionsImagesSplide = new Splide('.solutions-images-splide', {
        arrows: false,
        pagination: false,
        speed: 1000,
        type: 'fade',
        easing: 'ease-out',


    });

    solutionsController.sync(solutionsTextSplide);
    solutionsController.sync(solutionsImagesSplide);

    solutionsController.mount();
    solutionsTextSplide.mount();
    solutionsImagesSplide.mount();



    ``

    /**
     * Benefits scroll
     */



    const benfitsSplide = new Splide('.benefits-area-splide ', {


        breakpoints: {
            9000: {
                destroy: true,
            },
            1023: {
                destroy: false,


                direction: 'rtl',
                autoWidth: true,
                gap: '1rem',
                updateOnMove: true,
                arrows: false,
                padding: { left: '2rem', right: '2rem' },
            }
        }

    }).mount();
    function get_move() {

        const screen_width = window.innerWidth;
        const element_width = document.querySelector('.benefits-list').scrollWidth;
        const elRect = document.querySelector('.benefits-list').getBoundingClientRect();
        const element_offsetLeft = elRect.left;
        const how_much_to_move = element_width - screen_width + element_offsetLeft + 50;

        return how_much_to_move;


    }





    // /**
    //  * Logos entrance
    //  */

    // const allLogos = document.querySelectorAll('.clients-area .client-item');
    // const logosTl = gsap.timeline({
    //     scrollTrigger: {
    //         trigger: '.clients-list',
    //         start: 'top 80%',
    //         // end: 'bottom 60%',

    //     }

    // });

    // logosTl.from(allLogos, { y: 50, opacity: 0, stagger: 0.2, duration: .3, ease: "power2.out" });


    /**
     * Customers type alignment
     *
     */


    // function setCustomersTypesHeight() {
    //     let typeHeight;
    //     let summedHeight = 0;
    //     const allCustomerstypes = document.querySelectorAll('.client-type-item');
    //     let additionalHeight = 0;
    //
    //     //if is mobile screen
    //
    //
    //
    //
    //     if (window.innerWidth < 1024) {
    //         additionalHeight = 30
    //     } else {
    //         additionalHeight = 30
    //     }
    //
    //     allCustomerstypes.forEach(type => {
    //
    //         if (typeHeight) {
    //
    //             summedHeight += typeHeight + additionalHeight;
    //             type.style.transform = `translateY(${summedHeight}px)`;
    //         }
    //         typeHeight = type.querySelector('.inner-wrapper').clientHeight;
    //
    //
    //     });
    //     //document.querySelector('.customer-types-list').style.paddingBottom = `${summedHeight}px`;
    // }
    //
    // document.addEventListener('resize', setCustomersTypesHeight);
    // setCustomersTypesHeight();





    //check if to show mobile cta.
    function isBtnPrimaryOutOfView() {

        const btn = document.querySelector('.hero .btn-primary');
        if (!btn) return true;
        const rect = btn.getBoundingClientRect();

        return rect.bottom < 0 || rect.top > window.innerHeight;
    }

    // Example usage:
    document.addEventListener('scroll', () => {
        if (isBtnPrimaryOutOfView()) {
            // The button is out of the viewport
            document.querySelector('.mobile-cta').classList.add('show');
        } else {
            document.querySelector('.mobile-cta').classList.remove('show');
        }
    });





});